module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAIVBMVEUAAAApLzMpLzMpLzMpLzMpLzMpLzMpLzPh6O16gISRl5z6FN7hAAAACHRSTlMAcO//gABg3+gx/ogAAABkSURBVHgBY2BUNiYAjFwZko0JAkOGYsKKzBmMiQDDXlEHEEA4WBkdZCgaVTSqaFTRqKJRRZNBIpaYDCRFEGYHFsYgVzSqaFTRChCrC0pjMrqIbYYoE9NcEyasyIwhrJhgE1IUAAYtY/A1Ac4SAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/1f3b9.png
// module id = 791
// module chunks = 0